module.exports = __webpack_public_path__ + "img/undraw_reading_0re1.11273645.svg";